import "materialize-css";

const MaterialSidebarDirective = function () {
    return function (scope, element, attrs) {

        /*
            Commented out during MaterializeCSS update
            Options no longer the same, see link below for new version documentation
            https://materializecss.com/sidenav.html
        */
        
        var options = {
            //menuWidth: 320, //menuWidth not part of SidenavOptions, might need to be addressed separately
            //edge: 'left',  //edge is part of SidenavOptions, but not allowed for some reason ('left' is the default value, so can be ignored)
            //closeOnClick: true //closeOnClick not part of SidenavOptions, might be default
        }

        //if (attrs.edge)
        //    options.edge = attrs.edge;
        //if (attrs.menuWidth)
        //    options.menuWidth = attrs.menuWidth;
        //if (attrs.closeOnClick)
        //    options.closeOnClick = attrs.closeOnClick === "true";

        $(element).sidenav(options);
    }
};

export { MaterialSidebarDirective };